import React from "react";
import { Link } from "react-router-dom";
import "../styles/PrivacyPolicy.css";

const CHANNELS = [
  {
    title: "Email",
    type: "info@oneglobalmarketplace.com",
    admin: "Response within 24 hours",
    purpose: "Best for detailed questions, documentation, or account issues.",
  },
  {
    title: "WhatsApp",
    type: "+91 83091 20616",
    admin: "Mon–Sat, 10 AM–7 PM IST",
    purpose: "Fastest for quick questions about a specific property or booking.",
  },
  {
    title: "Contact Form",
    type: "Available on our Contact page",
    admin: "Response within 24 hours",
    purpose: "Send us your name, number, and message directly from the site.",
  },
];

const FAQS = [
  {
    q: "Is One Global Marketplace a broker or agent?",
    a: "No. OGM is a listings platform that connects buyers/renters with sellers, developers, and registered brokers. We are not a party to any transaction and don't charge commission.",
  },
  {
    q: "How do I schedule a live video tour of a property?",
    a: "Open the property you're interested in and use the \"Book a Tour\" option. An agent will join a live video call at your scheduled time to walk you through the property.",
  },
  {
    q: "How do I list my property or register as a broker/developer?",
    a: "Use \"Register as Developer/Agent\" in the footer, or register directly via WhatsApp or Google sign-in from the same page.",
  },
  {
    q: "Who do I contact if a listing looks inaccurate or suspicious?",
    a: "Email us at info@oneglobalmarketplace.com with the property link and details -- we'll review it. Remember that listing accuracy is the responsibility of the seller/developer/broker who posted it.",
  },
  {
    q: "Is my personal data safe?",
    a: "Yes -- see our Privacy Policy for full details on what we collect and how it's protected.",
  },
];

/**
 * Static Customer Support page: real contact channels (email, WhatsApp,
 * contact form) plus a short FAQ section.
 */
export default function CustomerSupport() {
  return (
    <div className="pp-page">
      <div className="pp-container">

        <div className="pp-hero">
          <div className="pp-hero-badge">Support</div>
          <h1 className="pp-h1">Customer Support</h1>
          <p className="pp-intro">
            Need help with a listing, a booking, or your account? Here's how to
            reach us, and answers to the questions we hear most often.
          </p>
        </div>

        <section className="pp-section">
          <h2 className="pp-h2">Get in Touch</h2>
          <div className="pp-cookie-grid">
            {CHANNELS.map((c) => (
              <div className="pp-cookie-card" key={c.title}>
                <div className="pp-cookie-title">{c.title}</div>
                <p style={{ fontSize: 13.5, fontWeight: 600, color: "#334155", margin: "0 0 8px", wordBreak: "break-word" }}>
                  {c.type}
                </p>
                <div className="pp-cookie-row"><span>Hours</span><b>{c.admin}</b></div>
                <p style={{ fontSize: 13, color: "#64748b", margin: "10px 0 0" }}>{c.purpose}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="pp-section">
          <h2 className="pp-h2">Frequently Asked Questions</h2>
          {FAQS.map((f, i) => (
            <div key={i} style={{ marginBottom: 22 }}>
              <h3 className="pp-h3">{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </section>

        <div className="pp-contact">
          <div className="pp-contact-icon">💬</div>
          <h2 className="pp-h2" style={{ marginBottom: 8 }}>Still need help?</h2>
          <p style={{ margin: "0 0 16px" }}>
            Send us a message and we'll get back to you within 24 hours.
          </p>
          <Link to="/contact" className="pp-contact-link">
            Visit our Contact Page →
          </Link>
        </div>

      </div>
    </div>
  );
}
